import { useContext } from 'react';
import { TitleContext } from '../../providers/TitleProvider/TitleProvider';

export default function useTitle() {
	const { setTitle } = useContext(TitleContext);
	return setTitle;
}
